/**
 * VQE Polish (EDG-fix-hardening, M2): the source of truth for `showRunActions`
 * on the cursor/gutter action bars (`CursorStatementActions`,
 * `CursorStatementGutterActions`).
 *
 * `QueryEditorTabContent` computes two different statements for the cursor
 * position: `currentCursorStatement` (genuinely parse-reachable — survived
 * `isPencilReachableStatement`) and the wider `affordanceStatement`
 * (pencil-reachable OR a confirmed-broken raw segment, so the parse-error
 * chip/squiggle can attach to a broken, non-pencil-reachable statement too —
 * EDG-11..15). `statementRange`/`statementText` deliberately use the wider
 * `affordanceStatement`. `showRunActions` must NOT: offering Run/Peek on a
 * statement that only qualified via the broken-statement path would just
 * error at the engine, so it stays gated on the narrower
 * `currentCursorStatement` even though the chip/squiggle intentionally use
 * the broader one.
 *
 * Extracted as a pure, exported helper (mirrors `resolveLiveQuery` in
 * `liveQuery.ts`) so `showRunActions.test.ts` exercises the REAL derivation
 * instead of a copy of it, and so it stays out of `QueryEditorTabContent.tsx`
 * (which must export ONLY the component for React Fast Refresh).
 */
export function resolveShowRunActions(
  currentCursorStatement: { multiStatement: boolean } | null,
): boolean {
  return currentCursorStatement?.multiStatement ?? false;
}
